import { render } from "./ContrattoEditDialog.vue?vue&type=template&id=18103e56&scoped=true"
import script from "./ContrattoEditDialog.vue?vue&type=script&lang=js"
export * from "./ContrattoEditDialog.vue?vue&type=script&lang=js"

import "./ContrattoEditDialog.vue?vue&type=style&index=0&id=18103e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18103e56"]])

export default __exports__